import HTTP from '../http'
const BASE_URL = '/tsg-author'

const imgUrl = process.env.VUE_APP_API_IMG_URL
// const imgUrl = location.host.indexOf("dev.") != -1|| location.host.indexOf("test") != -1 || location.host.indexOf(":80") != -1 ? 'https://fdfs.cnknowledge.com/' :"https://kpp.cnknowledge.com/"
const url = "https://web.tonghangpingyi.com/txpy-web"
export default {
  imgUrl,
  url,
  getUserInfo(data) {
    return HTTP.get(BASE_URL + '/web/sso/getUserInfo', data)
  },
  setUserInfo(data) {
    return HTTP.json(BASE_URL + '/web/sso/setUserInfo', data)
  },
  findProvinceList(data) {
    return HTTP.get(BASE_URL + '/web/common/findProvinceList', data)
  },
  findAreaList(data) {
    return HTTP.get(BASE_URL + '/web/common/findAreaList', data)
  }
}